import { BusStopRow } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopRow";
import { ChangeEstimatedTime } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/Itinerary/ChangeEstimatedTime";
import { FC, useState } from "react";
import {
  AlternativeTransportItinerary,
  AlternativeTransportItineraryStop,
  StopReference,
  VehicleStatus,
} from "shared/types/alternativeTransport";

type Props = {
  id: string;
  travelDate: Date | null;
  itinerary: AlternativeTransportItinerary | null;
  vehicleStatus: VehicleStatus;
  distributionStopReferences: Array<StopReference>;
};

export const BusStopTableBody: FC<Props> = ({
  id,
  travelDate,
  itinerary,
  vehicleStatus,
  distributionStopReferences,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStop, setSelectedStop] =
    useState<AlternativeTransportItineraryStop | null>(null);

  const closeModal = () => {
    setShowModal(false);
    setSelectedStop(null);
  };

  const openModalForStop = (stop: AlternativeTransportItineraryStop) => {
    setSelectedStop(stop);
    setShowModal(true);
  };

  const allStops: AlternativeTransportItineraryStop[] = (() => {
    if (!itinerary) return [];
    if (itinerary.returnStops !== null && itinerary.returnStops.length > 0) {
      return itinerary.stops.concat(itinerary.returnStops.slice(1));
    }
    return itinerary.stops;
  })();

  if (!allStops.length) {
    return null;
  }

  const lastArrivedIndex = allStops
    .map((stop) => !!stop.actualArrivalTime)
    .lastIndexOf(true);

  return (
    <>
      {allStops.map((stop, index) => (
        <BusStopRow
          // eslint-disable-next-line react/no-array-index-key -- index is required since the same stop can repeat
          key={index}
          stop={stop}
          index={index}
          vehicleStatus={vehicleStatus}
          currentStopIndex={lastArrivedIndex}
          openModalForStop={() => openModalForStop(stop)}
        />
      ))}
      {travelDate && (
        <ChangeEstimatedTime
          id={id}
          travelDate={travelDate}
          distributionStopReferences={distributionStopReferences}
          showModal={showModal}
          stop={selectedStop}
          closeModal={closeModal}
        />
      )}
    </>
  );
};
